module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "_Слой_2",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 85 85"
    }
  }, [_c('g', {
    attrs: {
      "id": "_Слой_1-2"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "cls-2",
    attrs: {
      "cx": "42.5",
      "cy": "42.5",
      "r": "42.5"
    }
  }), _c('g', [_c('g', [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M39.23,26.79c0-2.91,.02-5.82,0-8.73-.03-3.03-.41-3.32-3.44-2.72-12.37,2.45-20.38,14.55-17.81,26.9,2.61,12.52,14.86,20.41,27.31,17.57,1.05-.24,2.07-.61,3.11-.87,.53-.13,1.12-.15,1.36,.48,.24,.64-.21,1.04-.72,1.24-1,.39-2.01,.77-3.06,1.02-12.68,3.08-25.67-4.44-29.45-17.01-3.71-12.35,3.09-25.89,15.15-30.18,12.66-4.5,26.31,1.46,31.37,13.7,.08,.2,.21,.39,.24,.6,.16,.95,1.34,2.24-.22,2.72-1.21,.37-1.24-1.2-1.59-2.01-.77-1.79-1.62-3.51-2.73-5.12-.89-1.3-1.71-1.72-3.04-.39-4.12,4.11-8.3,8.15-12.52,12.16-1.25,1.18-1.13,2.05,.02,3.2,2.51,2.51,4.93,5.12,7.36,7.72,.47,.51,1.32,1.08,.53,1.89-.81,.84-1.38-.04-1.86-.52-3.08-3.16-6.12-6.37-9.18-9.55-.83-.86-.82-1.94-.82-3.02,0-3.02,0-6.03,0-9.05Zm2.03-2h0c0,2.69-.01,5.37,.01,8.06,0,.5-.18,1.16,.46,1.4,.61,.23,.96-.33,1.33-.69,3.86-3.73,7.71-7.48,11.58-11.2,.89-.85,.94-1.58-.07-2.37-3.28-2.58-6.96-4.21-11.09-4.83-1.48-.22-2.23,.34-2.21,1.91,.04,2.58,0,5.16,0,7.73Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M66.52,59.9c1.98,.1,.98-6.9,.82-9.58-.1-1.71-1.03-2.49-2.71-2.48-2.48,.01-4.95,0-7.43,.01-1.52,0-2.52,.7-2.54,2.29-.06,3.01-.02,6.03,0,9.04,0,.4,.11,.99,.57,.93,.45-.05,.46-.66,.47-1.08,.03-1.4,.03-2.8,.08-4.2,.03-.66,.19-1.35,1.05-1.29,.68,.04,.81,.66,.81,1.2,.01,4.63,.01,9.26-.01,13.89,0,.55-.27,1.13-.92,1.1-.63-.03-.85-.6-.89-1.15-.06-.97-.04-1.94-.08-2.9-.03-.74,.2-1.7-.49-2.12-3.37-2.02-2.7-5.3-2.75-8.37-.01-.86,0-1.72,0-2.58,.01-5.48,.25-5.76,5.78-6.79,.3-.06,.8-.12,.85-.28,.25-.84-.6-.67-.98-.92-3.17-2.09-4.24-5.22-2.8-8.3,1.3-2.78,4.21-4.13,7.27-3.34,2.56,.66,4.1,2.36,4.52,4.92,.45,2.82-.63,5.05-3.07,6.59-.44,.27-1.29,.66-1.25,.81,.23,.85,1.04,.47,1.62,.53,3.92,.41,5,1.57,5.05,5.58,.03,2.37,0,4.74,0,7.11,0,1.09,.09,2.43-.77,3.04-2.32,1.64-2.26,3.93-2.2,6.32,.02,.74,.04,1.74-.97,1.71-.94-.03-.97-1-.97-1.76,0-4.2,0-8.4,0-12.6,0-.76,.03-1.73,.98-1.75,1-.01,.96,.98,.96,1.72,.02,1.57-.09,4.71,0,4.72Zm-5.41-25.31c-2.26-.07-4.34,1.95-4.39,4.27-.05,2.35,1.88,4.44,4.15,4.5,2.29,.05,4.32-1.92,4.39-4.26,.07-2.35-1.85-4.43-4.15-4.5Z"
    }
  })]), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "60.5",
      "y": "62",
      "width": "2",
      "height": "8",
      "rx": ".94",
      "ry": ".94"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745be5a2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/dashboard/obrativshikhsya.vue
// module id = 1539087d57198dee6124
// module chunks = 89